/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassSignupRef,
  ApClassSignupRefOptional,
  ApClassSignupRefMetaI,
  ApClassSignupRefTrackedI,
} from "./ap-class-signup-ref";
import {
  ApClassSignupRefTracked,
  ApClassSignupRefMeta,
} from "./ap-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassWlResultRef,
  UnifiedClassWlResultRefOptional,
  UnifiedClassWlResultRefMetaI,
  UnifiedClassWlResultRefTrackedI,
} from "./unified-class-wl-result-ref";
import {
  UnifiedClassWlResultRefTracked,
  UnifiedClassWlResultRefMeta,
} from "./unified-class-wl-result-ref";

/**
 *
 * @export
 * @interface ApClassWlResultRef
 */
export interface ApClassWlResultRefOptional extends UnifiedClassWlResultRefOptional {
  /**
   *
   * @type {ApClassSignupRef}
   * @memberof ApClassWlResultRef
   */
  assignId?: ApClassSignupRefOptional;
}

export interface ApClassWlResultRef
  extends ApClassWlResultRefOptional, UnifiedClassWlResultRef {
  /**
   *
   * @type {ApClassSignupRef}
   * @memberof ApClassWlResultRef
   */
  assignId: ApClassSignupRef;
}

export interface ApClassWlResultRefTrackedI extends UnifiedClassWlResultRefOptional {
  /**
   *
   * @type {ApClassSignupRef}
   * @memberof ApClassWlResultRef
   */
  assignId?: ApClassSignupRefTrackedI;
  assignIdIsSet: boolean;
}

transformDatesMap.set(
  "ApClassWlResultRef",
  function (model: ApClassWlResultRef) {
    const transformDatesassignId = transformDatesMap.get("ApClassSignupRef");
    if (transformDatesassignId && model.assignId) {
      transformDatesassignId(model.assignId);
    }
  },
);

export type ApClassWlResultRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<ApClassSignupRefMetaI>;
}>;

export var ApClassWlResultRefMeta: ApClassWlResultRefMetaI =
  {} as ApClassWlResultRefMetaI;
ApClassWlResultRefMeta = typeMeta("ApClassWlResultRef", {
  assignId: propertyMeta("assignId", false, true, true, ApClassSignupRefMeta),
});

const metaI = ApClassWlResultRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassWlResultRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassWlResultRefMeta.assignId;
});

export class ApClassWlResultRefTracked
  extends UnifiedClassWlResultRefTracked
  implements ApClassWlResultRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: ApClassSignupRefTracked = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | ApClassSignupRefTracked) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  constructor(config?: ApClassWlResultRefOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
    this.assignId?.setIds();
  }
  assignFrom(
    config: ApClassWlResultRefOptional,
    options?: AssignOptions,
  ): ApClassWlResultRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = new ApClassSignupRefTracked(config.assignId, options);
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ApClassWlResultRefTrackedI {
    const cloned = {} as ApClassWlResultRefTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId?.removeUnset(filter);
    } else {
      //cloned.assignIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ApClassWlResultRefTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;
    this.assignId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassWlResultRefMeta.assignId,
      ApClassWlResultRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;
    return this.assignId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
